
import XHeader from 'vux/src/components/x-header/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import $ from 'jquery';
import axios from 'axios';
import {getken} from '@/api/getToken';
import {promptMessage,baseUrl} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
export default {
data () {
return {
searchVal:'',
onFetching: false,
downLoadingShow:false,
bottomCount: 10,
downLoadingTxt:'正在加载',
teamList:[
]
}
},
components: {
XHeader,Search,Scroller,LoadMore,XButton
},
methods: {
getData(){
axios.post(urlConfig.regionalTeam).then(response => {
let imgurl = baseUrl + urlConfig.regionalTeamGetImage;
this.teamList = [];
debugger;
if(response.status ==200){
let datas = response.data.rows
for(let i=0;i<datas.length;i++){
console.log(urlConfig.regionalTeamGetImage,56)

this.teamList.push({title:datas[i].name,tx:imgurl+datas[i].image +'?token=' + window.localStorage.getItem('token'),src:imgurl+datas[i].qrCode +'?token=' + window.localStorage.getItem('token'),tel:datas[i].tel,regional:datas[i].area,dection:datas[i].serverContent,hosipital:datas[i].hospitalName.replace(/,/g,"<br/>"),})
}
}else {
console.log("response.statusText="+response.statusText)
promptMessage('提示',response.statusText);
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
promptMessage('提示',error);
})
},
onSubmit () {
this.$refs.search.setBlur()
console.log(this.searchVal,5)

},
onScrollBottom () {
this.downLoadingShow = true;
if (this.onFetching) {

} else {


this.downLoadingTxt = '到底啦！'
setTimeout(() => {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
this.onFetching = false;
}, 2000)

}
},
onBlur () {
$('.weui-icon-clear').hide();
},
onFocus(){
$('.weui-icon-clear').show();
},
contentHeight(){
$('.content').css('height',(window.innerHeight-46) +'px');
}
},
mounted(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
getken(this.getData());
this.contentHeight();
let _this = this;
window.onresize =function(){
_this.contentHeight();
}
}
}



// WEBPACK FOOTER //
// ./src/project/regionalServiceProject/regionalTeamList.vue